type _UiTheme = {
  // 多选下拉筛选文本位置
  // default:element-plus默认光标交互
  // self:输入框总在最前边 且输入值时遮挡选中项
  // popper:筛选文本框在下拉选项中 且支持全选/反选/重置等
  multipleSelectFilter: 'self' | 'popper' | 'default';
};
type UiTheme = Partial<_UiTheme>;

const defaultTheme: UiTheme = {
  multipleSelectFilter: 'default'
};

function setUiTheme(newTheme: UiTheme) {
  Object.assign(defaultTheme, newTheme);
}

function getUiTheme(key: keyof UiTheme) {
  return key ? defaultTheme[key] : defaultTheme;
}

export type { UiTheme };

export { setUiTheme, getUiTheme };
